<template>
    <div class="w-full">
        <div>
            <InputText 
                v-model="textValue" 
                placeholder="hhh:mm" 
                @blur="onBlur" 
                :readonly="readonly" 
                class="w-full"
            />
        </div>
        <div>
            <small v-if="invalid" class="p-error"> 
                {{ $t('DemurrageCalculator.messages.error_valid_hrs_minutes') }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Number,
            default: null,
        },
        readonly: {
            type: Boolean,
            required: true
        }
    },

    emits: ["update:modelValue"],
    
    data() {
        return {
            invalid: false,
            textValue: this.formatTime(this.modelValue),
        }
    },

    watch: {
        modelValue(newVal) {
            const formatted = this.formatTime(newVal);
            if (formatted !== this.textValue) {
                this.textValue = formatted;
            }
        },
    },

    methods: {
        formatTime(value) {
            if (value == null || isNaN(value)) return "";
            const hours = Math.floor(value / 60);
            const minutes = value % 60;
            
            // padStart(2) assicura il minimo di due cifre (05:00), 
            // ma non taglia le cifre extra (102:00)
            return `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}`;
        },

        parseTime(str) {
            // Modificato: \d{1,} permette un numero indefinito di cifre per le ore
            const match = str.match(/^(\d{1,}):(\d{1,2})$/);
            if (!match) return null;

            const hours = parseInt(match[1], 10);
            const minutes = parseInt(match[2], 10);

            if (minutes > 59) return null;
            
            return hours * 60 + minutes;
        },

        onBlur() {
            this.invalid = false;
            const total = this.parseTime(this.textValue);
            
            if (total === null && this.textValue !== "") {
                this.invalid = true;
                this.textValue = this.formatTime(this.modelValue);
            } else {
                this.$emit("update:modelValue", total);
                // Riapplichiamo la formattazione per pulire eventuali input sporchi (es: "1:5" -> "01:05")
                this.textValue = this.formatTime(total);
            }
        },
    }
};
</script>